import PropTypes from "prop-types";
import {
  Box,
  Divider,
  Drawer,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { ChartBar as ChartBarIcon } from "../icons/chart-bar";
import { Cog as CogIcon } from "../icons/cog";
import { Selector as SelectorIcon } from "../icons/selector";
import { Logo } from "./logo";
import { NavItem } from "./nav-item";
import { Link } from "react-router-dom";
import * as auth from "../services/authService";
import { Users as UsersIcon } from "../icons/users";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
const items = [
  {
    href: "/home",
    icon: <ChartBarIcon fontSize="small" />,
    title: "Home",
  },
  {
    href: "/settings",
    icon: <CogIcon fontSize="small" />,
    title: "Settings",
  },
  {
    href: "/account",
    icon: <AccountCircleIcon fontSize="small" />,
    title: "Account",
  },
];

export const DashboardSidebar = (props) => {
  const { open, onClose } = props;
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"), {
    defaultMatches: true,
    noSsr: false,
  });

  const content = (
    <>
      {auth.getCurrentUser() && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <div>
            <Box sx={{ p: 3 }}>
              <Link to="/home">
                <Logo
                  sx={{
                    height: 42,
                    width: 42,
                  }}
                />
              </Link>
            </Box>
            <Box sx={{ px: 2 }}>
              <Box
                sx={{
                  alignItems: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.04)",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  px: 3,
                  py: "11px",
                  borderRadius: 1,
                }}
              >
                <div>
                  <Typography color="inherit" variant="subtitle1">
                    {auth.getCurrentUser().name
                      ? auth.getCurrentUser().name
                      : "loading"}
                  </Typography>
                  <Typography color="neutral.400" variant="body2">
                    Account :{" "}
                    {auth.getCurrentUser().account &&
                      auth.getCurrentUser().account}
                  </Typography>
                </div>
                <SelectorIcon
                  sx={{
                    color: "neutral.500",
                    width: 14,
                    height: 14,
                  }}
                />
              </Box>
            </Box>
          </div>
          <Divider
            sx={{
              borderColor: "#2D3748",
              my: 3,
            }}
          />
          <Box sx={{ flexGrow: 1 }}>
            {items.map((item) => (
              <NavItem
                key={item.title}
                icon={item.icon}
                href={item.href}
                title={item.title}
              />
            ))}
          </Box>
          <Divider sx={{ borderColor: "#2D3748" }} />
          <Box
            sx={{
              px: 2,
              py: 3,
            }}
          >
            <Typography color="neutral.100" variant="subtitle2">
              My Cheque
            </Typography>
            <Typography color="neutral.500" variant="body2">
              Version: 1.0.0
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );

  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open
        PaperProps={{
          sx: {
            backgroundColor: "neutral.900",
            color: "#FFFFFF",
            width: 280,
          },
        }}
        variant="permanent"
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: "neutral.900",
          color: "#FFFFFF",
          width: 280,
        },
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );
};

DashboardSidebar.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
